import { render, staticRenderFns } from "./AiAssistant.vue?vue&type=template&id=612d3951&scoped=true"
import script from "./AiAssistant.vue?vue&type=script&lang=js"
export * from "./AiAssistant.vue?vue&type=script&lang=js"
import style0 from "./AiAssistant.vue?vue&type=style&index=0&id=612d3951&prod&scoped=true&lang=scss"
import style1 from "./AiAssistant.vue?vue&type=style&index=1&id=612d3951&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612d3951",
  null
  
)

export default component.exports